import React from 'react';
import { useAppContext } from '../../context/AppState.jsx';
import { GenericSubmenu as GenericSubmenuComponent } from '../../components';

export default function GenericSubmenu({ items }) {
	return <GenericSubmenuComponent items={items} />;
}
